import { type ReactNode } from 'react';
import useBreakpoint from 'use-breakpoint';

interface IScreenClasses {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  xxl?: boolean;
}

interface IGridVisibilityProps extends IScreenClasses {
  children?: ReactNode;
}

const hidden = ({
  screenClass,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
}: IScreenClasses & { screenClass: string }) => {
  if (screenClass === 'xxl') return xxl;
  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

export const screenSizeConfig = { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1600 };

// The children are wrapped in a fragment: a function component returns an element under the
// React 16 typings (the former code returned `children` itself, which renders the same).
export const Hidden = ({
  xs = false,
  sm = false,
  md = false,
  lg = false,
  xl = false,
  xxl = false,
  children,
}: IGridVisibilityProps) => {
  const { breakpoint } = useBreakpoint(screenSizeConfig, 'lg');
  return hidden({ screenClass: breakpoint, xs, sm, md, lg, xl, xxl }) ? null : <>{children}</>;
};

export const Visible = ({
  xs = false,
  sm = false,
  md = false,
  lg = false,
  xl = false,
  xxl = false,
  children,
}: IGridVisibilityProps) => {
  const { breakpoint } = useBreakpoint(screenSizeConfig, 'lg');
  return !hidden({ screenClass: breakpoint, xs, sm, md, lg, xl, xxl }) ? null : <>{children}</>;
};
